import { useEffect } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { DealerAuthProvider } from './context/DealerAuthContext'
import DealerAuthGuard from './guards/DealerAuthGuard'
import DealerLayout from './components/DealerLayout/DealerLayout'
import LoginPage from './pages/LoginPage/LoginPage'
import ForgotPasswordPage from './pages/ForgotPasswordPage/ForgotPasswordPage'
import ResetPasswordPage from './pages/ResetPasswordPage/ResetPasswordPage'
import DashboardPage from './pages/DashboardPage/DashboardPage'
import RequestsPage from './pages/RequestsPage/RequestsPage'
import ProfilePage from './pages/ProfilePage/ProfilePage'
import './components/ui/dealer-ui.css'

// портал дилера: dealer.verrafied.ai / dev.dealer.verrafied.ai, маршруты от корня хоста
export default function DealerApp() {
  const { t, i18n } = useTranslation()

  useEffect(() => {
    document.documentElement.lang = i18n.language
    document.title = t('dealer.document_title')
  }, [i18n.language, t])

  return (
    <div className="dealer-app">
      <DealerAuthProvider>
        <Routes>
          <Route path="login" element={<LoginPage />} />
          <Route path="forgot-password" element={<ForgotPasswordPage />} />
          <Route path="reset-password" element={<ResetPasswordPage key="reset" mode="reset" />} />
          <Route path="set-password" element={<ResetPasswordPage key="set" mode="set" />} />
          <Route
            element={
              <DealerAuthGuard>
                <DealerLayout />
              </DealerAuthGuard>
            }
          >
            <Route index element={<DashboardPage />} />
            <Route path="requests" element={<RequestsPage />} />
            <Route path="profile" element={<ProfilePage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </DealerAuthProvider>
    </div>
  )
}
